import * as React from 'react';
import {ToggleButton, ToggleButtonGroup} from '@mui/material';
import {useAppTranslation} from 'services/i18n';
import {type ApprovalRequestType} from 'model/approval';

const COURSE_MODE: ApprovalRequestType = 'request_course';
const TOPIC_MODE: ApprovalRequestType = 'request_topic';

/**
 * Segmented/Režim from the design: one bordered pill, sentence case, the active
 * half filled in the space's own primary.
 */
const toggleStyle = {
    // the column layout would stretch the pill to full width
    alignSelf: 'flex-start',
    // the pill is a flex item of the scrolling column and hides its own overflow,
    // which lets it shrink to nothing -- on a short screen it would vanish while
    // the fields below, whose min-height is their content, keep their height
    flexShrink: 0,
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    overflow: 'hidden',
    background: 'var(--color-white)',
    '& .MuiToggleButton-root': {
        border: 0,
        borderRadius: 0,
        padding: '10px 18px',
        fontSize: '13px',
        fontWeight: 500,
        textTransform: 'none',
        color: '#757575',
        '&.Mui-selected': {
            background: 'var(--color-primary15)',
            color: 'var(--color-primary60)',
            '&:hover': {background: 'var(--color-primary15)'}
        }
    }
};

/**
 * Which of the two shapes a request takes. Only ever offered while the record
 * is being created -- once saved, the mode is immutable
 * (`Update::IMMUTABLE_ATTRIBUTES`).
 */
export const RequestModeToggle = ({value, onChange}: {
    value: ApprovalRequestType,
    onChange: (value: ApprovalRequestType) => void,
}) => {
    const t = useAppTranslation();

    return <ToggleButtonGroup exclusive size={'small'} value={value} sx={toggleStyle} className={'tw-mb-24'}
        onChange={(e, next) => {
            // an unselected group would leave the form without a mode
            if (next) {
                onChange(next);
            }
        }}>
        <ToggleButton value={COURSE_MODE}>{t('approvals.requests.mode.course')}</ToggleButton>
        <ToggleButton value={TOPIC_MODE}>{t('approvals.requests.mode.topic')}</ToggleButton>
    </ToggleButtonGroup>;
};
